import { useEffect, useState } from 'react';

export function useOnceEffect(callFn) {
  const [called, setCalled] = useState(false);

  useEffect(() => {
    if (!called && callFn()) {
      setCalled(true);
    }
  }, [callFn, called]);
}
